var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallengeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Challenges",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Challenge-UI---desktop",
    transform: "translate(-622.000000, -317.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(344.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(278.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.638546,1.27186024 C20.8969281,1.10879679 20.0405664,1.21344187 19.2342934,1.51543945 C19.2411933,1.08238152 19.2391489,0.659483315 19.2268823,0.253856624 L12.3141448,0.253856624 L5.40140737,0.253856624 C5.38914078,0.659483315 5.38684079,1.08238152 5.3939963,1.51543945 C4.58772323,1.21344187 3.73161711,1.10879679 2.98974366,1.27186024 C1.89290561,1.51162955 1.14822107,2.26090866 0.892922555,3.37974747 C0.5594245,4.84046074 1.29363133,6.51529004 2.96009939,8.09614196 C4.27313617,9.34146924 6.03467034,10.3775064 7.89510394,11.0175685 C8.665855,12.0975464 9.65254924,12.9677261 10.9045086,13.4967934 C10.722043,14.1594609 10.081369,16.0791394 8.53322244,17.2538566 L12.3141448,17.2538566 L16.0953228,17.2538566 C14.5469207,16.0791394 13.9065022,14.1594609 13.7240366,13.4967934 C14.975996,12.9677261 15.9629458,12.0975464 16.7334413,11.0173145 C18.5936193,10.3775064 20.355409,9.34146924 21.6684458,8.09614196 C23.3349139,6.51503605 24.0691207,4.84046074 23.7356227,3.37974747 C23.4800686,2.26090866 22.7353841,1.51162955 21.638546,1.27186024 Z M4.06945958,6.94123616 C2.86426661,5.79725206 2.26243679,4.59840549 2.45998008,3.73330561 C2.57600163,3.22277984 2.85455556,2.93627583 3.33601942,2.83061478 C3.97158238,2.69117267 4.80059976,2.90300276 5.48344023,3.32285305 C5.63856154,5.153888 6.00247053,7.06620068 6.68352212,8.76287337 C5.70347228,8.25641149 4.80341086,7.63768475 4.06945958,6.94123616 Z M20.5588301,6.94123616 C19.8248788,7.63743075 18.9248174,8.25641149 17.9447675,8.76312737 C18.6260747,7.06645467 18.9899837,5.15414199 19.1448494,3.32310705 C19.8276899,2.90351075 20.6567073,2.69168065 21.2922702,2.83086877 C21.7737341,2.93652983 22.052288,3.22303384 22.1683096,3.7335596 C22.3658529,4.59865948 21.7640231,5.79750605 20.5588301,6.94123616 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 6.81427261,
    y: 18.2538566,
    width: 11,
    height: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeLabel);
export default __webpack_public_path__ + "static/media/challenge-label.7d76321be3902283b3d056f79bb01250.svg";
export { ForwardRef as ReactComponent };